<template>
	<div id="mainCanvas" @contextmenu.prevent="">
		<!--背景图绘制层-->
		<canvas id="defectCanvas" class="absoluteCanvas" v-bind:width="canvasWidth" v-bind:height="canvasHeight" />
		<!--绘制矩形层-->
		<canvas id="pointsCanvas" class="absoluteCanvas" v-bind:width="canvasWidth" v-bind:height="canvasHeight" />
		<!--标尺信息-->
		<rule-bar-layout class="ruleCanvas" :length="totalLength" :data="defectSign" v-show="showRuleBar" v-bind:width="canvasWidth" v-bind:height="50" />
		<!--框选和显示密度层-->
		<select-area-layout class="absoluteCanvas" :width="canvasWidth" :height="canvasHeight" :pointRadius="pointRadius" :imageLocation="imageLocation" :pointsData="pointsData" :scale="scale" v-on:selectComplete="selectComplete" :showPoints="showPoints" v-on:selectedPoints="handleSelectedPoints" />
	</div>
</template>

<script>
	import RuleBarLayout from './RuleBarLayout'
	import SelectAreaLayout from './SelectAreaLayout'
	export default {
		components: {
			RuleBarLayout,
			SelectAreaLayout,
		},
		props: {
			imageUri: {
				type: String,
				required: true,
			},
			defectRect: {
				type: Object,
				required: false,
			},
			showPoints: {
				type: Boolean,
				required: false,
			},
			pointsData: {
				type: Array,
				required: false,
			},
			showRuleBar: {
				type: Boolean,
				default: true,
			},
			defectSign: {
				type: Array,
			},
			totalLength: {
				type: Number,
			},
		},
		data() {
			return {
				/**
				 * 界面宽度。
				 */
				clientWidth: 0,
				/**
				 * 画布宽度。
				 */
				canvasWidth: 0,
				/**
				 * 画布高度。
				 */
				canvasHeight: 0,
				/**
				 * 默认画布，背景图画布。
				 */
				canvas: null,
				/**
				 * 存放鼠标位置。
				 */
				origin: [],
				width2height: [0, 0],
				selectCanvas: null,
				pointsCanvas: null,
				scale: 1,
				pointRadius: 2,
				imageLocation: {
					x: 0,
					y: 0,
					w: 0,
					h: 0,
				},
				image: null,
				imageLoaded: false,
				selectedCoord: [],
			}
		},
		computed: {
			FModelID() {
				return 180324037
			},
		},
		watch: {
			imageUri(val) {
				if (val) {
					console.log('watch imageUri', val)
					this.imageLoaded = false
					this.initCanvas(val)
				}
			},
			defectRect: {
				handler(val) {
					if (val == null) {
						return
					}
					//绘制矩形
					this.drawRect2(val.x, val.y, val.w, val.h, val.type, this.pointsCanvas)
					//抠图。
					this.cutRectImage(val.x, val.y, val.w, val.h)
				},
				deep: true,
			},
			showPoints(val) {
				if (this.pointsData.length == 0) return
				this.drawPoints()
			},
			pointsData(val) {
				this.drawPoints()
			},
		},
		methods: {
			handleSelectedPoints(selectedPoints) {
				if (selectedPoints) {
					console.log('绘制选中的矩形框。')
					//绘制选中的矩形框。
					this.drawRect2(selectedPoints.x, selectedPoints.y, 0, 0, 2, this.pointsCanvas)
				} else {
					this.drawPoints()
				}
			},
			selectComplete(data) {
				//触发框选结束事件
				this.$emit('selectComplete', data)
			},
			/**
			 * 初始化canvas大图。
			 */
			initCanvas(dataURLs) {
				if (dataURLs.indexOf('http') != 0) {
					dataURLs = 'data:image/png;base64,' + dataURLs
				}
				this.image = new Image()
				this.image.src = dataURLs
				this.image.setAttribute('crossOrigin', 'anonymous')
				this.image.onload = () => {
					//减去标尺的高度
					var h = this.canvasHeight
					var scale = h / this.image.height
					console.log('canvasHeight', this.canvasHeight)
					console.log('this.image.height', this.image.height)
					console.log('this.image.width', this.image.width)
					//根据图片的高宽比例，显示最合适的大小。
					if (scale * this.image.width > this.canvasWidth) {
						scale = (scale * this.image.width) / this.canvasWidth
					}
					// if (this.image.width > this.image.height) {
					// 	scale = this.canvasWidth / this.image.width
					// } else {
					// 	scale = this.canvasHeight / this.image.height
					// }
					console.log('scale', scale)
					//计算开始绘制点，为保证图片居中。
					var left = this.canvasWidth / 2 - (this.image.width * scale) / 2
					var top = this.canvasHeight / 2 - (this.image.height * scale) / 2
					var width = this.image.width * scale
					var height = this.image.height * scale
					//设置图片在canvas中的位置和大小。
					this.imageLocation.x = left
					this.imageLocation.y = top
					this.imageLocation.w = width
					this.imageLocation.h = height
					//设置缩放比例。
					this.scale = scale
					//绘制图片。
					this.drawImage(this.image)
					//触发初始化完成的事件，将缩放比例传出去。
					this.imageLoaded = true
					console.log('触发初始化完成的事件')
				}
			},
			/**
			 * 绘制一个中心点。
			 */
			drawCenterPoint(x, y) {
				var ctx = this.pointsCanvas.getContext('2d')
				ctx.strokeStyle = 'rgb(122, 225, 90)'
				ctx.fillStyle = 'rgb(122, 225, 90)'
				ctx.beginPath()
				ctx.arc(x, y, this.pointRadius, 0, 2 * Math.PI)
				ctx.fill()
				ctx.stroke()
			},
			/**
			 * 绘制所有的缺陷点。
			 */
			drawPoints() {
				var ctx = this.pointsCanvas.getContext('2d')
				//清空上次绘制记录。
				ctx.clearRect(0, 0, this.canvasWidth, this.canvasHeight)
				if (this.showPoints) {
					ctx.strokeStyle = '#f00'
					ctx.fillStyle = '#f00'
					this.pointsData.forEach(coord => {
						ctx.beginPath()
						ctx.arc(this.imageLocation.x + coord.x * this.scale, this.imageLocation.y + coord.y * this.scale, this.pointRadius, 0, 2 * Math.PI)
						ctx.fill()
						ctx.stroke()
					})
				}
			},
			/**
			 * 绘制图片。
			 */
			drawImage(image) {
				var cxt = this.canvas.getContext('2d')
				cxt.setTransform(1, 0, 0, 1, 0, 0)
				//先清空画布。
				cxt.clearRect(0, 0, this.canvasWidth, this.canvasHeight)
				// 恢复先前渲染上下文所进行的变换
				cxt.restore()
				cxt.drawImage(image, this.imageLocation.x, this.imageLocation.y, this.imageLocation.w, this.imageLocation.h)
			},
			/**
			 * 进行抠图裁剪。
			 */
			cutRectImage(x, y, width, height) {
				var w = 285
				var h = 285
				x = x - w / 2 + width / 2
				y = y - h / 2 + height / 2
				var cv = document.createElement('canvas')
				cv.height = h
				cv.width = w
				var ctx = cv.getContext('2d')
				ctx.fillStyle = '#fff'
				ctx.fillRect(0, 0, w, h)
				var self = this
				//通过定时器检查大图是否加载完成。
				var timer = setInterval(function() {
					if (self.imageLoaded) {
						clearInterval(timer)
						ctx.drawImage(self.image, x, y, w, h, 0, 0, w, h)
						var imageBase64 = cv.toDataURL('image/png')
						self.$emit('selectRect', imageBase64)
					}
				}, 10)
			},
			/**
			 * X点坐标转换，将鼠标坐标转换成图片实际位置的X点坐标。
			 */
			parseImageOriginX(value) {
				return parseFloat(((value - this.imageLocation.x) / this.scale).toFixed(2))
			},
			/**
			 * 绘制目标区域
			 */
			drawRect2(x, y, cx, cy, type, cav) {
				var width = 285
				var height = 285
				var w = width * this.scale
				var h = height * this.scale
				//将缺陷点的坐标转换成x，y坐标。
				x = this.imageLocation.x + x * this.scale - (width / 2) * this.scale + (cx / 2) * this.scale
				y = this.imageLocation.y + y * this.scale - (height / 2) * this.scale + (cy / 2) * this.scale
				// y = 左上角 Y 坐标 + 缺陷 Y 坐标 - 目标框的一半  + 缺陷高度
				var ctx = this.pointsCanvas.getContext('2d')
				//清空上次绘制记录。
				//ctx.clearRect(0, 0, this.canvasWidth, this.canvasHeight);
				//重新绘制底图。
				//this.drawImage(this.image);
				//重新绘制所有的数据坐标点。
				if (this.showPoints) {
					this.drawPoints()
				} else {
					ctx.clearRect(0, 0, this.canvasWidth, this.canvasHeight)
				}
				ctx.fillStyle = 'rgba(255, 255, 255, 0)'
				ctx.strokeStyle = 'red'
				ctx.lineWidth = 1
				if (type == 1) {
					ctx.strokeStyle = 'red'
					ctx.lineWidth = 1
				} else {
					ctx.strokeStyle = 'yellow'
					ctx.lineWidth = 1
				}
				ctx.strokeRect(x, y, w, h)
				//绘制中心点
				this.drawCenterPoint(x + w / 2, y + h / 2)
			},
		},
		created() {},
		mounted() {
			this.clientWidth = document.documentElement.clientWidth
			this.canvasWidth = document.getElementById('mainCanvas').offsetWidth
			this.canvasHeight = document.getElementById('mainCanvas').offsetHeight
			this.canvas = document.getElementById('defectCanvas')
			this.pointsCanvas = document.getElementById('pointsCanvas')
			this.initCanvas(this.imageUri)
			//等待图片绘制完成后，绘制密度点。
			setTimeout(() => {
				if (this.showPoints) {
					this.drawPoints()
				}
			}, 1000)
		},
	}
</script>

<style scoped>
	#mainCanvas {
		position: absolute;
		left: 0;
		top: 0;
		right: 0;
		bottom: 0;
	}
	.absoluteCanvas {
		position: absolute;
		left: 0;
		top: 0;
	}
	.ruleCanvas {
		position: absolute;
		left: 0;
		right: 0;
		height: 50px;
		bottom: 0;
	}
</style>
